const SearchBtn = ({ label, callback }) => {
  const page = window.initialState.page;
  const searchParams = window.location.search;
  const clickEvent = () => {
    callback();
  };
  if (page !== "search") {
    return (
      <a href={`${window.initialState.locationsUrl}/${searchParams}`} className="button" >
        {label}
      </a>
    );
  } else {
    return (
      <button type="button" className="button" onClick={() => clickEvent()}>
        {label}
      </button>
    );
  }
};
export default SearchBtn;
